import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"

import A2PStatusPanel from "../a2p/A2PStatusPanel"
import DialogHeader from "../components/DialogHeader"

/** Shown right after the brand is submitted; same status view as the SMS card. */
export default function BrandRegistrationPendingDialog({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogHeader title="Texting registration submitted" onClose={onClose} />
      <DialogContent>
        <A2PStatusPanel onContinueRegistration={onClose} />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
